import { Select, SelectProps } from 'zens-storybook'
import React from 'react'
import { StyleSheet } from 'react-native'
import { useZones } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
})

interface Props extends Omit<SelectProps<number>, 'items' | 'onSelect'> {
  extraItems?: { value: number; title: string }[]
  zoneIds?: number[]
  floorId?: number
  companyId: number
  onChange?: (value: number) => void
}

const ZoneSelect = (props: Props) => {
  const { onChange, companyId, value, extraItems = [], zoneIds, floorId, ...otherProps } = props
  const zones = useZones({ companyId, floorId }, { enabled: floorId !== 0 })

  const items = zones.data
    ?.filter((zone) => !zoneIds || zoneIds.includes(zone.id))
    .map((zone) => ({
      value: zone.id,
      title: zone.name,
    }))

  return (
    <Select
      style={styles.container}
      onSelect={onChange}
      items={[...extraItems, ...(items || [])]}
      testID="ZoneSelect.Container"
      value={value}
      {...otherProps}
    />
  )
}

export default ZoneSelect
